import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"60vh","overflow-y":"scroll"} }
const _hoisted_2 = { style: {"text-align":"left"} }


import { ref, defineExpose, computed, unref, onBeforeUnmount } from 'vue'
import { ElDialog, ElTabs, ElTabPane, ElMessage, ElButton } from 'element-plus'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import Clipboard from 'clipboard'
const __default__ = {
  name: 'DataDetail'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

const dialogVisible = ref(false)
const activeName = ref('json')
const graphData = ref({} as any)
const clipboard = ref(null as any)
const xml = computed(() => {
  return unref(graphData)?.xml
})

const copyJsonContent = computed(() => {
  return JSON.stringify(unref(graphData)?.json, null, 2)
})
const show = (data: any) => {
  dialogVisible.value = true
  graphData.value = data
}
const handleOpened = () => {
  // 这里使用选择器，因为直接使用.m-flow-btn-copy复制会失效(原因示明)
  const copyEl = document.querySelectorAll('.m-flow-btn-copy')
  clipboard.value = new Clipboard(copyEl, {
    // 复制需要临时创建一个textarea文件，可以放在自定义的.m-dialog-data-detail内
    container: document.querySelector('.m-dialog-data-detail') as Element
  })
  clipboard.value.on('success', function (e: any) {
    ElMessage.success('复制成功')
    e.clearSelection()
  })
  clipboard.value.on('error', function () {
    ElMessage.error('复制失败')
  })
}
const handleClose = () => {
  if (clipboard.value) {
    clipboard.value.destroy()
  }
}
onBeforeUnmount(() => {
  if (clipboard.value) {
    clipboard.value.destroy()
  }
})
__expose({
  show
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    title: "查看流程数据",
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    width: "60%",
    onOpened: handleOpened,
    onClose: handleClose,
    "custom-class": "m-dialog-data-detail",
    "append-to-body": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(ElButton), {
        type: "primary",
        class: "m-flow-btn-copy",
        "data-clipboard-text": copyJsonContent.value
      }, {
        default: _withCtx(() => [
          _createTextVNode("复制JSON")
        ]),
        _: 1
      }, 8, ["data-clipboard-text"]),
      _createVNode(_unref(ElButton), {
        type: "primary",
        class: "m-flow-btn-copy",
        "data-clipboard-text": xml.value
      }, {
        default: _withCtx(() => [
          _createTextVNode("复制XML")
        ]),
        _: 1
      }, 8, ["data-clipboard-text"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ElTabs), {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTabPane), {
              label: "json",
              name: "json"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(VueJsonPretty), {
                  data: graphData.value.json
                }, null, 8, ["data"])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElTabPane), {
              label: "xml",
              name: "xml"
            }, {
              default: _withCtx(() => [
                _createElementVNode("pre", _hoisted_2, _toDisplayString(xml.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})